export const environment = {
    production: false,
    stage: false,
    dev: true,
    local: true,
    api_host: 'https://infront-news-ai-test.azurewebsites.net/api/news_editorial/',
    api_code: '1bJJMnsak1UsrRvXtnydrSTEAsjObHuOYS5U9ta7p1QmAzFuFWx-nQ==',
    italian: false,
    msalConfig: {
        auth: {
            clientId: '95534938-d94a-4a3e-b4af-7e962ca55762',
            authority: "https://login.microsoftonline.com/23371993-8e9a-4de5-97db-90d3e293e863",
            redirectUri: '/',
        }
    },
    apiConfig: {
        scopes: ['user.read'],
        uri: 'https://graph.microsoft.com/v1.0/me'
    },
    signalRUrl: 'https://newsai-signal-app-test-awf4hyafbecmhpbf.westeurope-01.azurewebsites.net/notifications',
    signalRGroup: 'Stage'
};


export const mockUser = {
    "@odata.context": 'test',
    businessPhones: [],
    displayName: "Doe, John",
    givenName: "John",
    jobTitle: "Unemployed",
    mail: "John@.nowhere.com.se",
    mobilePhone: null,
    officeLocation: "Neverland",
    preferredLanguage: 'EN',
    surname: "Doe",
    userPrincipalName: "John@.nowhere.com.se",
    id: 'testLocalNew'
}
